import Home from '@/components/templates/HomeView.vue'
import About from '@/components/templates/AboutView.vue'
import CustomerVoice from '@/components/templates/CustomerVoiceView.vue'
import DreamPost from '@/components/templates/DreamPostView.vue'
import DreamPostDetail from '@/components/templates/DreamPostDetailView.vue'
import HidekiInfo from '@/components/templates/HidekiInfoView.vue'
import Info from '@/components/templates/InfoView.vue'
import LookMe from '@/components/templates/LookMeView.vue'
import Shop from '@/components/templates/ShopView.vue'
import History from '@/components/templates/HistoryView.vue'
import Saying from '@/components/templates/SayingView.vue'
import HRCard from '@/components/templates/HRCardView.vue'
import Movie from '@/components/templates/MovieView.vue'
import Exhibit from '@/components/templates/ExhibitView.vue'

export default [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about/:id',
    name: 'about',
    component: About
  },
  {
    path: '/customer',
    name: 'customer',
    component: CustomerVoice
  },
  {
    path: '/dreampost',
    name: 'dreampost',
    component: DreamPost
  },
  {
    path: '/dreampost/detail',
    name: 'dreampost_detail',
    component: DreamPostDetail
  },
  {
    path: '/hidekiinfo',
    name: 'hidekiinfo',
    component: HidekiInfo
  },
  {
    path: '/info',
    name: 'info',
    component: Info
  },
  {
    path: '/lookme',
    name: 'lookme',
    component: LookMe
  },
  {
    path: '/hrcard',
    name: 'hrcard',
    component: HRCard
  },
  {
    path: '/shop',
    name: 'shop',
    component: Shop
  },
  {
    path: '/history',
    name: 'history',
    component: History
  },
  {
    path: '/saying',
    name: 'saying',
    component: Saying
  },
  {
    path: '/movie',
    name: 'movie',
    component: Movie
  },
  {
    path: '/exhibit',
    name: 'exhibit',
    component: Exhibit
  },
  {
    path: '*',
    redirect: '/'
  }
]